<template>
  <div class="row" ref="formulario">
    <div class="col-12">
      <card class="custom-shadow-card-header" v-if="isIndex()">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                Agregar Pluviómetro
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog :title="title" :visible.sync="modals.create" width="60%">
            <form>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group has-label">
                    <label class="text-transform-none">Nombre *</label>
                    <fg-input
                      id="name"
                      type="text"
                      name="name"
                      v-model="model.name"
                      placeholder="Nombre"
                      v-validate="modelValidations.name"
                      :error="getError('name', true)"
                    ></fg-input>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group has-label">
                    <label class="text-transform-none">Latitud *</label>
                    <fg-input
                      id="latitude"
                      type="text"
                      name="latitude"
                      v-model="model.latitude"
                      placeholder="Latitud"
                      v-validate="modelValidations.latitude"
                      v-on:change="geoMap"
                      :error="getError('latitude', true)"
                    ></fg-input>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group has-label">
                    <label class="text-transform-none">Longitud *</label>
                    <fg-input
                      id="longitude"
                      type="text"
                      name="longitude"
                      v-model="model.longitude"
                      placeholder="Longitud"
                      v-validate="modelValidations.longitude"
                      v-on:change="geoMap"
                      :error="getError('longitude', true)"
                    ></fg-input>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group has-label">
                    <label class="text-transform-none"
                      >Altitud (m s. n. m.)</label
                    >
                    <fg-input
                      id="altitude"
                      type="text"
                      name="altitude"
                      v-model="model.altitude"
                      placeholder="Altitud"
                      v-validate="modelValidations.altitude"
                      :error="getError('altitude', true)"
                    ></fg-input>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-label">
                    <label>Empresa(s) *</label>
                    <el-select
                      placeholder="Selecionar..."
                      id="listBusinesses"
                      style="width: 100%"
                      class="select-primary mb-3 shadow-sm"
                      v-model="model.businessesIds"
                      filterable
                      clearable
                      multiple
                      collapse-tags
                      @change="
                        selectAllFromSelect(
                          'model.businessesIds',
                          listBusinesses
                        )
                      "
                    >
                      <el-option
                        v-for="option in listBusinesses"
                        class="select-primary selected-all"
                        :value="option.id"
                        :label="option.name"
                        :key="option.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-label">
                    <label>Descripcion</label>
                    <br />
                    <el-input
                      id="description"
                      maxlength="500"
                      show-word-limit
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      placeholder="Descripcion..."
                      v-model="model.description"
                      class="shadow-sm"
                    ></el-input>
                    <br />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-label mt-4">
                    <div
                      ref="map"
                      class="map"
                      v-if="renderComponent"
                      style="height: 500px"
                    ></div>
                    <div
                      id="toolbarDiv"
                      class="esri-component esri-widget"
                      v-if="renderComponent"
                    ></div>
                  </div>
                </div>
              </div>
            </form>
            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                Cancelar</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                Confirmar
              </button>
            </span>
          </el-dialog>
          <el-dialog
            v-if="isShow()"
            title="Registro seleccionado..."
            :visible.sync="modals.read"
            width="70%"
            top="2%"
          >
            <p>{{ $t('common_words.selected_record_info') }}</p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ rowData.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>Descripcion:</strong>
                        </h6>
                        {{ rowData.description }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(business, index) in rowData.business"
                          v-bind:key="index"
                        >
                          <el-tag type="info">{{ business.name }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.geo_position') }}:</strong
                          >
                        </h6>
                        Lat: {{ rowData.latitude }} - Lon:
                        {{ rowData.longitude }} - Alt: {{ rowData.altitude }}
                        <span v-if="rowData.altitude != 'N/A'"
                          >(m s. n. m.)</span
                        >
                        <div class="col-12">
                          <br />
                          <div
                            ref="map"
                            class="map"
                            style="height: 500px"
                          ></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer footer-date-at" v-if="rowData">
              <p class="text-white">
                <small>
                  {{ $t('common_words.created_on') }}:
                  {{ rowData.created_at }}
                </small>
              </p>
            </div>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            :showRefresh="true"
            @searchedQuery="searchedQuery"
            @refreshTable="refreshTable"
            class="mr-3 mt-3"
          ></card-header>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                type="index"
                width="65"
                :resizable="false"
                fixed="left"
              ></el-table-column>
              <template v-for="column in tableColumns">
                <template v-if="isComponentFormatter(column.formatter)">
                  <el-table-column
                    :key="column.label"
                    :min-width="column.minWidth"
                    :prop="column.prop"
                    :label="column.label"
                    :sortable="column.sortable"
                    :align="column.align"
                    :fixed="column.fixed"
                    :resizable="false"
                    v-if="showColumn(column.show)"
                  >
                    <template
                      slot-scope="props"
                      v-if="validateTypeFormatter(column.formatter)"
                    >
                      <div
                        v-if="column.formatter"
                        :is="column.formatter"
                        :row="props.row"
                        :column="column.prop"
                      ></div>
                      <template v-else>{{
                        getProperty(props.row, column.prop)
                      }}</template>
                    </template>
                  </el-table-column>
                </template>
                <template v-else>
                  <el-table-column
                    :key="column.label"
                    :min-width="column.minWidth"
                    :prop="column.prop"
                    :label="column.label"
                    :formatter="getFormatter(column.formatter)"
                    :sortable="column.sortable"
                    :align="column.align"
                    :fixed="column.fixed"
                    :resizable="false"
                    v-if="showColumn(column.show)"
                  >
                    <el-table-column
                      v-for="column in column._columns"
                      :key="column.label"
                      :min-width="column.minWidth"
                      :prop="column.prop ? column.prop : 'na'"
                      :label="column.label"
                      :formatter="getFormatter(column.formatter)"
                      :sortable="column.sortable"
                      :align="column.align"
                      :fixed="column.fixed"
                      :resizable="false"
                    />
                  </el-table-column>
                </template>
              </template>
              <el-table-column
                min-width="180"
                prop="props.business"
                :label="$t('common_words.associated_companies')"
                :sortable="true"
                :resizable="false"
                align="center"
              >
                <template slot-scope="scope">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="scope.row.business.length > 0"
                    :hidden="scope.row.business.length == 1 ? true : false"
                    :value="200"
                    :max="scope.row.business.length - 1"
                  >
                    <el-button plain type="info" size="small">{{
                      scope.row.business[0].name
                    }}</el-button>
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                v-if="isShow() || isUpdate() || isDelete()"
                :min-width="110"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete() && props.row.state == 'Habilitado'"
                      v-tooltip.top-center="'Deshabilitar'"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete() && props.row.state == 'Deshabilitado'"
                      v-tooltip.top-center="'Habilitar'"
                      class="btn-success btn-simple btn-link custom-margin-actions"
                      @click="handleActivate(props.$index, props.row)"
                    >
                      <em class="fa fa-check custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <export-tables
          :pdf="{
            filename: `${$t('common_words.rain_accumulator')}.pdf`,
            route: 'devices/rainaccumulators/pdf',
          }"
          :xls="{
            filename: `${$t('common_words.rain_accumulator')}.xlsx`,
            route: 'devices/rainaccumulators/excel',
          }"
        />
        <br />
      </card>
    </div>
  </div>
</template>
<script>
import { Pagination as LPagination } from 'src/components/index';
import configTable from './RainAccumulatorTable';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import store from '@/store';
import Fuse from 'fuse.js';
import moment from 'moment';
import { Axios } from 'src/class/Axios.js';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },
  computed: {
    ...configTable().search,
  },
  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinMenu,
    MixinForm,
    MixinArcgisMap,
  ],
  data() {
    return {
      pagination: {},
      tableColumns: [],
      searchQuery: '',
      tableData: [],
      rowData: null,
      modelValidations: {
        name: {
          required: true,
        },
        latitude: {
          required: true,
        },
        longitude: {
          required: true,
        },
        /*altitude: {
          required: true,
        },*/
        businessesIds: {
          required: true,
        },
      },
      model: {
        name: null,
        latitude: null,
        longitude: null,
        altitude: null,
        description: null,
      },
      listBusinesses: [],
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      renderComponent: true,
    };
  },

  methods: {
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },

    refreshTable() {
      this.loadData();
    },

    loadData() {
      this.showHideLoading(true);
      this.tableData = [];
      Axios.getMasters('devices/rainaccumulators').then((response) => {
        let responseData = response.data.data;
        this.listBusinesses =
          responseData.listBusinesses.length > 0
            ? this.concatAll(responseData.listBusinesses)
            : [];
        this.tableData = responseData.tableData;
        this.fuseSearch = new Fuse(this.tableData, {
          useExtendedSearch: true,
          threshold: 0.3,
          keys: this.tableColumns.map((prop) => {
            return prop.prop;
          }),
        });
        this.showHideLoading();
      });
    },

    validateTypeFormatter(value) {
      if (typeof value !== 'function') {
        return true;
      }
      return false;
    },

    getProperty(data, property) {
      if (!data[property]) {
        const keys = property.toLowerCase().split('.');
        let result = null;
        keys.forEach((key, i) => {
          if (i === 0) result = data[key];
          else result = result[key];
        });
        return result;
      } else return data[property];
    },

    getFormatter(formatter) {
      if (typeof formatter === 'function') return formatter;
      else return null;
    },

    showColumn(show) {
      if (typeof show === 'undefined') return true;
      else if (typeof show !== 'undefined' || show !== null) return show;
    },

    isComponentFormatter(formatter) {
      return typeof formatter === 'object';
    },

    handleView(_, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.center.lat = this.rowData.latitude
        ? parseFloat(this.rowData.latitude)
        : this.center.lat;
      this.center.lng = this.rowData.longitude
        ? parseFloat(this.rowData.longitude)
        : this.center.lng;
      this.modals['read'] = true;

      this.loadBaseMap(null);
    },

    handleEdit(_, row) {
      this.title = 'Editar Pluviómetro';
      row.altitude = row.altitude == 'N/A' ? null : row.altitude;
      row.description = row.description == 'N/A' ? null : row.description;
      this.model = Object.assign({}, row);
      this.model.route = 'devices/rainaccumulators';
      this.geoMap();
      this.errors.clear();
      this.modals['create'] = true;
    },

    handleDelete(_, row) {
      this.model.id = row.id;
      SweetAlert.disable(`Pluviómetro ${row.name}`).then((result) => {
        if (result.value) this.handleState();
      });
    },

    handleActivate(_, row) {
      this.model.id = row.id;
      SweetAlert.default(
        `Pluviómetro ${row.name}`,
        '¿Deseas Habilitar el Pluviómetro?',
        i18n.t('common_words.yes_enable'),
        1
      ).then((result) => {
        if (result.value) this.handleState();
      });
    },

    handleState() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'devices/rainaccumulators';
        Axios.destroyMaster(this.model)
          .then((response) => this.modifyTable(1, this.model.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    geoMap($event) {
      if ($event != undefined) {
        let regex = /^-?[0-9]\d*([.|,]\d+)?$/;
        if ($event.target.value.match(regex) == null) {
          switch ($event.target.classList) {
            case 'latitud':
              this.model.latitude = null;
              break;

            case 'longitud':
              this.model.longitude = null;
              break;

            /*case 'altitud':
              this.model.altitude = null;
              break;
            */
            default:
              break;
          }
        } else {
          // $event.target.classList.remove("custom-has-error");
        }
      }
      this.center.lat = this.model.latitude
        ? parseFloat(this.model.latitude)
        : this.center.lat;
      this.center.lng = this.model.longitude
        ? parseFloat(this.model.longitude)
        : this.center.lng;
      this.loadMap();
    },

    loadMap() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadMapRegistrationForm();
        this.showHideLoading();

        setTimeout(() => {
          document.getElementById('toolbarDiv').style = 'top: 23%;right: 30px';
        }, 10);
      });
    },

    openModal(name) {
      if (name == 'create') {
        this.geoMap();
        this.title = 'Agregar Pluviómetro';
        this.$validator.reset();
        this.model = {
          name: null,
          latitude: null,
          longitude: null,
          altitude: null,
          businessesIds: [],
          description: null,
        };
      }
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    async validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (this.model.businessesIds.length == 0) {
          let sel = document.getElementById('listBusinesses');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (isValid) this.addEditRainAccumulator();
      });
    },

    addEditRainAccumulator() {
      this.showHideLoading(true);
      if (this.model.route == 'devices/rainaccumulators') {
        if (this.isUpdate()) {
          Axios.updateMaster(this.model)
            .then((response) => {
              this.modifyTable(1, this.model.id, response);
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          this.model.route = 'devices/rainaccumulators';
          Axios.saveMaster(this.model)
            .then((response) => {
              this.modifyTable(0, null, response);
            })
            .catch((error) => {
              this.closeModal('create');
              this.showMessageErrors(error);
            });
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.loadData();
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('devices');
  },

  destroyed() {
    this.deselectedItemOnMenu('devices');
  },
};
</script>
<style>
.el-textarea__inner:focus {
  outline: 0 !important;
  border-color: #6ba652 !important;
}
</style>
